import Fetcher from '../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination
} from '../../constants'
import { THSSavingGoalsResponse, THSSavingGoalsUpdateData } from './types'
import { TDashboardHistoryRequest } from '../Dashboard/types'
import { IHistoryGoalsItem } from '../Dashboard/Providers/types'

const fetcher = new Fetcher({})

export const getSavingGoalsData = async (params) =>
  fetcher.request<unknown, THSSavingGoalsResponse>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}`,
    method: HTTP_METHODS.GET,
    params
  })

export const saveSavingGoalsData = async (
  data: THSSavingGoalsUpdateData,
  params
) =>
  fetcher.request<THSSavingGoalsUpdateData, THSSavingGoalsResponse>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}`,
    method: HTTP_METHODS.PATCH,
    data,
    params
  })

export const getHistorySavingsCommunity = (uuid: string, data) =>
  fetcher.request<
    TDashboardHistoryRequest,
    ResponseWithPagination<IHistoryGoalsItem>
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.HISTORY}${API_DICTIONARY.COMMUNITY}${uuid}/`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getHistorySavingsHospital = (uuid: string, data) =>
  fetcher.request<
    TDashboardHistoryRequest,
    ResponseWithPagination<IHistoryGoalsItem>
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.HISTORY}${API_DICTIONARY.HOSPITAL}${uuid}/`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getHistorySavingsHealthSystem = (uuid: string, data) =>
  fetcher.request<
    TDashboardHistoryRequest,
    ResponseWithPagination<IHistoryGoalsItem>
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.HISTORY}${API_DICTIONARY.HEALTH_SYSTEM}${uuid}/`,
    method: HTTP_METHODS.GET,
    ...data
  })
